import React, { useState, useEffect } from "react";
import {
  Heart,
  Phone,
  MapPin,
  Menu,
  X,
  Users,
  Mail,
  Facebook,
  Instagram,
  Clock,
  Award,
  Shield,
  MessageCircle,
} from "lucide-react";

import logo from "../../assets/logo/logo.jpg";
import care from "../../assets/logo/care.jpg"
import elder from "../../assets/imageelderhome.jpeg";
import home from "../../assets/logo/home.jpg"
import { Link } from "react-router-dom";
export default function HeartlandCareHome() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    // Scroll to top when this page loads
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      title: "Personal Care",
      description:
        "Compassionate assistance with daily activities including bathing, dressing, grooming (Nail and foot care included), and mobility support.",
      icon: "👤",
    },
    {
      title: "Companionship",
      description:
        "Engaging social interaction, conversation, activities, and emotional support to combat loneliness.",
      icon: "💝",
    },
    {
      title: "Homemaking",
      description:
        "Light housekeeping, meal preparation, laundry, and maintaining a clean, safe living environment.",
      icon: "🏠",
    },
    {
      title: "Respite Care",
      description:
        "Temporary relief for family caregivers, providing peace of mind and quality care for loved ones.",
      icon: "⏰",
    },
    {
      title: "Dementia Care",
      description:
        "Specialized compassionate care for individuals living with dementia, including memory support and behavioral assistance.",
      icon: "🧠",
    },
    {
      title: "Palliative Care",
      description:
        "Compassionate end-of-life care focused on comfort, dignity, and quality of life for patients and their families.",
      icon: "🤝",
    },
  ];
  const locations = ["Surrey"];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}

      {/* Hero Section */}
      <section
        id="home"
        className="relative py-20 overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg, #f0fdf4 0%, #fff5f4 30%, #ffe8e6 70%, #ffd4d1 100%)",
        }}
      >
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute top-20 left-10 w-72 h-72 rounded-full blur-3xl"
            style={{ backgroundColor: "#65c063" }}
          ></div>
          <div
            className="absolute top-40 right-20 w-64 h-64 rounded-full blur-3xl"
            style={{ backgroundColor: "#f5a09e" }}
          ></div>
          <div
            className="absolute bottom-20 right-10 w-96 h-96 rounded-full blur-3xl"
            style={{ backgroundColor: "#ffc4c0" }}
          ></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="inline-block">
                <span
                  className="px-4 py-2 rounded-full text-sm font-medium text-white"
                  style={{
                    background: "linear-gradient(135deg, #65c063, #29a060)",
                  }}
                >
                  Welcome to Heartland Care Services
                </span>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Providing Compassionate
                <span style={{ color: "#f5a09e" }}> Care </span>
                for Your Loved Ones
              </h1>

              <p className="text-lg text-gray-600 leading-relaxed">
                At Heartland Care Services, we understand that your loved ones
                deserve the best care possible. Our dedicated team provides
                personalized support, ensuring their well-being and enhancing
                their quality of life in the comfort of home.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <a href="tel:+16047226460">
                  <button
                    className="text-white px-8 py-4 rounded-full font-medium hover:shadow-xl transition-all flex items-center justify-center gap-2"
                    style={{
                      background: "linear-gradient(135deg, #65c063, #29a060)",
                    }}
                  >
                    <Phone className="w-5 h-5" />
                    Contact Us Today
                  </button>
                </a>

                <Link to="/services">
                  <button
                    className="text-white px-8 py-4 rounded-full font-medium hover:shadow-xl transition-all flex items-center justify-center gap-2"
                    style={{
                      background: "linear-gradient(135deg, #65c063, #29a060)",
                    }}
                  >
                    Learn More
                  </button>
                </Link>
              </div>

              <div className="flex items-center gap-8 pt-6">
                <div className="text-center">
                  <div
                    className="text-3xl font-bold"
                    style={{ color: "#65c063" }}
                  >
                    5+
                  </div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
                <div className="w-px h-12 bg-gray-300"></div>
                {/* <div className="text-center">
                  <div
                    className="text-3xl font-bold"
                    style={{ color: "#f5a09e" }}
                  >
                    50+
                  </div>
                  <div className="text-sm text-gray-600">Happy Clients</div>
                </div> */}
                <div className="w-px h-12 bg-gray-300"></div>
                <div className="text-center">
                  <div
                    className="text-3xl font-bold"
                    style={{ color: "#65c063" }}
                  >
                    24/7
                  </div>
                  <div className="text-sm text-gray-600">Support</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div
                className="absolute -top-6 -right-6 w-24 h-24 rounded-full blur-2xl"
                style={{ backgroundColor: "#f5a09e" }}
              ></div>
              <div
                className="absolute -bottom-6 -left-6 w-32 h-32 rounded-full blur-2xl"
                style={{ backgroundColor: "#ffc4c0" }}
              ></div>
              <img
                src={home}
                alt="Caregiver with elderly person"
                className="rounded-3xl shadow-2xl relative z-10 w-full"
              />
              <div className="absolute bottom-8 left-8 bg-white p-4 rounded-2xl shadow-xl z-20">
                <div className="flex items-center gap-3">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: "#ffe8e6" }}
                  >
                    <Shield className="w-6 h-6" style={{ color: "#65c063" }} />
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">
                      Licensed & Insured
                    </div>
                    <div className="text-sm text-gray-600">
                      Professional Care
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src={care}
                alt="Care team"
                className="rounded-3xl shadow-xl"
              />
              <div
                className="absolute -bottom-6 -right-6 text-white p-6 rounded-2xl shadow-xl"
                style={{
                  background: "linear-gradient(135deg, #65c063, #29a060)",
                }}
              >
                <Award className="w-12 h-12 mb-2" />
                <div className="font-bold text-xl">Since 2020</div>
                <div className="text-sm text-green-100">Trusted Provider</div>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <span
                  className="font-semibold text-sm uppercase tracking-wider"
                  style={{ color: "#65c063" }}
                >
                  Who We Are
                </span>
                <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">
                  Excellence in Home Care Services
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  At Heartland Care Services, we are committed to delivering
                  compassionate and professional care. Our experienced team
                  offers personalized support, companionship, hygiene
                  assistance, respite care, and reliable transportation.
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#dcfce7" }}
                  >
                    <Heart className="w-6 h-6" style={{ color: "#65c063" }} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">
                      Compassionate Care
                    </h3>
                    <p className="text-gray-600">
                      We treat every client with dignity, respect, and genuine
                      care.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#ffe8e6" }}
                  >
                    <Users className="w-6 h-6" style={{ color: "#f5a09e" }} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">
                      Experienced Team
                    </h3>
                    <p className="text-gray-600">
                      Our caregivers are trained, certified, and passionate
                      about helping others.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#dcfce7" }}
                  >
                    <Clock className="w-6 h-6" style={{ color: "#65c063" }} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">
                      Flexible Scheduling
                    </h3>
                    <p className="text-gray-600">
                      We work around your schedule to provide care when you need
                      it most.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section
        id="services"
        className="py-20"
        style={{
          background: "linear-gradient(135deg, #fff5f4 0%, #ffe8e6 100%)",
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span
              className="font-semibold text-sm uppercase tracking-wider"
              style={{ color: "#65c063" }}
            >
              Our Services
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">
              What Services We Provide
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              With personalized care plans tailored to unique needs, we offer a
              comprehensive range of services to support your loved ones at
              home.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 group border-2 border-transparent hover:border-[#65c063]"
              >
                <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/services">
              <button
                className="text-white px-8 py-4 rounded-full font-medium hover:shadow-xl transition-all"
                style={{
                  background: "linear-gradient(135deg, #65c063, #29a060)",
                }}
              >
                View All Services
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span
              className="font-semibold text-sm uppercase tracking-wider"
              style={{ color: "#65c063" }}
            >
              Why Choose Us
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2">
              Making a Positive Difference
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div
              className="text-center p-6 rounded-2xl"
              style={{ backgroundColor: "#dcfce7" }}
            >
              <div
                className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center"
                style={{ backgroundColor: "#65c063" }}
              >
                <Heart className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Personalized Care
              </h3>
              <p className="text-gray-600">
                Every client receives a customized care plan designed for their
                unique needs.
              </p>
            </div>

            <div
              className="text-center p-6 rounded-2xl"
              style={{ backgroundColor: "#fff5f4" }}
            >
              <div
                className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center"
                style={{ backgroundColor: "#f5a09e" }}
              >
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Licensed Professionals
              </h3>
              <p className="text-gray-600">
                All our caregivers are fully licensed, insured, and
                background-checked.
              </p>
            </div>

            <div
              className="text-center p-6 rounded-2xl"
              style={{ backgroundColor: "#dcfce7" }}
            >
              <div
                className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center"
                style={{ backgroundColor: "#65c063" }}
              >
                <Clock className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                24/7 Availability
              </h3>
              <p className="text-gray-600">
                We're here whenever you need us, day or night, weekday or
                weekend.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        className="py-20 text-white relative overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg, #f5a09e 0%, #e88580 50%, #f5a09e 100%)",
        }}
      >
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-4xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="text-xl text-pink-50 mb-8">
            Contact us today to discuss how we can provide the best care for
            your loved ones. Our team is ready to answer your questions and
            create a personalized care plan.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* CALL BUTTON */}
            <a
              href="tel:+16045127113"
              className="bg-white px-8 py-4 rounded-full font-medium hover:shadow-2xl transition-all flex items-center justify-center gap-2"
              style={{ color: "#f5a09e" }}
            >
              <Phone className="w-5 h-5" />
              Call: +1 604-512-7113
            </a>

            {/* SEND EMAIL → CONTACT PAGE */}
            <Link
              to="/contact"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white transition-all flex items-center justify-center gap-2 hover:text-[#f5a09e]"
            >
              <Mail className="w-5 h-5" />
              Send Email
            </Link>
          </div>
        </div>
      </section>
      {/* Service Areas */}
      {/* <section className="py-16 text-white" style={{background: 'linear-gradient(135deg, #65c063 0%, #29a060 50%, #65c063 100%)'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-3">We Serve the Following Areas</h2>
            <p className="text-green-50">Providing quality home care services across the Lower Mainland</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {locations.map((location, index) => (
              <div key={index} className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-opacity-20 transition-all">
                <MapPin className="w-8 h-8 mx-auto mb-3 text-green-100" />
                <div className="font-semibold text-lg">{location}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/16045127113"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform group"
        style={{ background: "#25D366" }}
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-7 h-7 text-white" />
        <span className="absolute right-16 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">
          Chat with us
        </span>
      </a>

      {/* Footer */}
    </div>
  );
}
